
import React, { useEffect, useState } from 'react'
import { Dropdown, Grid, Icon, Rail } from 'semantic-ui-react'
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash'
import { useTranslation } from 'react-i18next';
import { SetSearchArea } from "../../../../redux/actions/mainActions"
import "./SearchLocation.css"

const SearchLocation = ({ activeItem, setActiveItem }) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const source = [
    { value: 'af', image: "http://localhost:3000/static/media/location-icon.png", text:t("home:Iran") },
    { value: 'ax', image: "http://localhost:3000/static/media/location-icon.png", text:t("home:Iran1") },
    { value: 'al', image: "http://localhost:3000/static/media/location-icon.png", text:t("home:Iran2") },
    { value: 'dz', image: "http://localhost:3000/static/media/location-icon.png", text:t("home:Iran3") },
    { value: 'as', image: "http://localhost:3000/static/media/location-icon.png", text:t("home:Iran4") },

  ]



  const searchArea = useSelector((state) => state.main.searchArea)




  const handleSearchChange = (e, { value }) => {
    dispatch(SetSearchArea(value))
    setActiveItem("")

  }


  return <Grid centered verticalAlign="middle" >


    <Grid.Column width={16}>

      <Dropdown
        open={activeItem == "search-location"}
        icon="none"
        placeholder={t("home:SearchArea")}
        fluid
        search
        selection
        //clearable
        options={source}
        className="search-location"
        onChange={(e, data) => handleSearchChange(e, data)}
        onFocus={()=>setActiveItem( "search-location")}

        value={searchArea}
      />

    </Grid.Column>
  </Grid>
}
export default SearchLocation